import { type ReviewPromptGuideViewContent } from "./ReviewPromptGuideView";

interface KnockReviewPromptContent {
  title?: string;
  body?: string;
  yesButtonText?: string;
  noButtonText?: string;
  laterButtonText?: string;
  feedbackTitle?: string;
  feedbackBody?: string;
  feedbackPlaceholder?: string;
  feedbackSubmitText?: string;
  feedbackSupportText?: string;
  feedbackCancelText?: string;
  appreciationTitle?: string;
  appreciationBody?: string;
}

function trimString(value: unknown): string | undefined {
  return typeof value === "string" ? value.trim() : undefined;
}

export function normalizeContent(content: unknown): ReviewPromptGuideViewContent | undefined {
  if (typeof content !== "object" || content === null) {
    return undefined;
  }

  const raw = content as KnockReviewPromptContent;

  const title = trimString(raw.title);
  const yesButtonText = trimString(raw.yesButtonText);
  const noButtonText = trimString(raw.noButtonText);
  const laterButtonText = trimString(raw.laterButtonText);

  if (!title || !yesButtonText || !noButtonText || !laterButtonText) {
    return undefined;
  }

  return {
    title,
    body: trimString(raw.body),
    yesButtonText,
    noButtonText,
    laterButtonText,
    feedbackTitle: trimString(raw.feedbackTitle),
    feedbackBody: trimString(raw.feedbackBody),
    feedbackPlaceholder: trimString(raw.feedbackPlaceholder),
    feedbackSubmitText: trimString(raw.feedbackSubmitText),
    feedbackSupportText: trimString(raw.feedbackSupportText),
    feedbackCancelText: trimString(raw.feedbackCancelText),
    appreciationTitle: trimString(raw.appreciationTitle),
    appreciationBody: trimString(raw.appreciationBody),
  };
}
